function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { merchantAddressDeleteApi, merchantAddressListApi, merchantAddressSaveApi, merchantAddressSetDefaultApi, merchantAddressUpdateApi, merchantAddressUpdateShowApi } from '@/api/systemSetting';
import { cityListTree } from '@/api/logistics';
import { checkPermi } from '@/utils/permission';
import { Debounce } from '@/utils/validate';
import { validatePhone } from '@/utils/toolsValidate';
var defaultFormData = {
  id: 0,
  receiverName: '',
  receiverPhone: '',
  region: [],
  province: '',
  provinceId: undefined,
  city: '',
  cityId: undefined,
  district: '',
  districtId: undefined,
  street: '',
  detail: '',
  isDefault: false,
  isShow: false
};
export default {
  name: 'BusinessAddress',
  data: function data() {
    return {
      dialogVisible: false,
      btnLoading: false,
      listLoading: false,
      cityList: [],
      cascaderProps: {
        children: 'child',
        label: 'regionName',
        value: 'regionId'
      },
      tableData: {
        data: [],
        total: 0
      },
      formData: Object.assign({}, defaultFormData),
      rules: {
        region: [{
          required: true,
          message: '请选择省/市/区',
          trigger: 'change'
        }],
        detail: [{
          required: true,
          message: '请输入详细地址',
          trigger: 'blur'
        }],
        receiverName: [{
          required: true,
          message: '请输入商家姓名',
          trigger: 'blur'
        }],
        receiverPhone: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.getCityList();
    if (checkPermi(['distribution:address:list'])) this.getList();
  },
  methods: {
    checkPermi: checkPermi,
    /** 获取城市列表 */getCityList: function getCityList() {
      var _this = this;
      var cached = localStorage.getItem('cityList');
      if (cached) {
        this.cityList = this.trimCityTree(JSON.parse(cached));
      }
      cityListTree().then(function (res) {
        var trimmed = _this.trimCityTree(res);
        localStorage.setItem('cityList', JSON.stringify(trimmed));
        _this.cityList = trimmed;
      }).catch(function () {});
    },
    /** 过滤城市树：移除第4级（街道）的空子节点数据 */trimCityTree: function trimCityTree(data) {
      if (!data || !data.length) return [];
      return data.map(function (item) {
        if (item.child && item.child.length) {
          item.child = item.child.map(function (city) {
            if (city.child && city.child.length) {
              city.child = city.child.map(function (district) {
                if (district.child && district.child.length) {
                  district.child = district.child.map(function (street) {
                    if (street.child && !street.child.length) {
                      delete street.child;
                    }
                    return street;
                  });
                }
                return district;
              });
            }
            return city;
          });
        }
        return item;
      });
    },
    /** 级联选择器变化 */handleRegionChange: function handleRegionChange(value) {
      if (value && value.length > 0) {
        this.formData.provinceId = value[0];
        // 根据选中的 ID 查找对应的名称
        var _findName = function findName(list, id) {
          var _iterator = _createForOfIteratorHelper(list),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              if (item.regionId === id) return item.regionName;
              if (item.child && item.child.length) {
                var result = _findName(item.child, id);
                if (result) return result;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return '';
        };
        this.formData.province = _findName(this.cityList, value[0]);
        this.formData.cityId = value[1] || undefined;
        this.formData.city = value[1] ? _findName(this.cityList, value[1]) : '';
        this.formData.districtId = value[2] || undefined;
        this.formData.district = value[2] ? _findName(this.cityList, value[2]) : '';
        // 四级街道
        if (value[3]) {
          this.formData.street = _findName(this.cityList, value[3]);
        } else {
          this.formData.street = '';
        }
      } else {
        this.formData.province = '';
        this.formData.provinceId = undefined;
        this.formData.city = '';
        this.formData.cityId = undefined;
        this.formData.district = '';
        this.formData.districtId = undefined;
        this.formData.street = '';
      }
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    /** 添加 */handleAddAddress: function handleAddAddress() {
      this.formData = Object.assign({}, defaultFormData);
      this.dialogVisible = true;
    },
    /** 编辑 */handleEditAddress: function handleEditAddress(row) {
      this.formData = JSON.parse(JSON.stringify(row));
      // 回显级联选择器
      var ids = [];
      if (row.provinceId) ids.push(row.provinceId);
      if (row.cityId) ids.push(row.cityId);
      if (row.districtId) ids.push(row.districtId);
      // 根据 street 中文名称查找四级 ID
      if (row.street && row.districtId) {
        var streetId = this.findStreetId(row.districtId, row.street);
        if (streetId) ids.push(streetId);
      }
      this.formData.region = ids;
      this.dialogVisible = true;
    },
    /** 根据区/县ID和街道名称查找街道ID */findStreetId: function findStreetId(districtId, streetName) {
      var _findByName = function findByName(list, name) {
        var _iterator2 = _createForOfIteratorHelper(list),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            if (item.regionName === name) return item.regionId;
            if (item.child && item.child.length) {
              var result = _findByName(item.child, name);
              if (result) return result;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        return null;
      };
      var _findById = function findById(list, id) {
        var _iterator3 = _createForOfIteratorHelper(list),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var item = _step3.value;
            if (item.regionId === id) {
              return item.child && item.child.length ? _findByName(item.child, streetName) : null;
            }
            if (item.child && item.child.length) {
              var result = _findById(item.child, id);
              if (result) return result;
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        return null;
      };
      return _findById(this.cityList, districtId);
    },
    /** 提交保存 */
    submitForm: Debounce(function (formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.btnLoading = true;
          if (!_this2.formData.isShow) _this2.formData.isDefault = false;
          var data = {
            id: _this2.formData.id || undefined,
            receiverName: _this2.formData.receiverName,
            receiverPhone: _this2.formData.receiverPhone,
            province: _this2.formData.province,
            provinceId: _this2.formData.provinceId,
            city: _this2.formData.city,
            cityId: _this2.formData.cityId,
            district: _this2.formData.district,
            districtId: _this2.formData.districtId,
            street: _this2.formData.street || '',
            detail: _this2.formData.detail,
            isDefault: _this2.formData.isDefault,
            isShow: _this2.formData.isShow
          };
          var api = _this2.formData.id === 0 ? merchantAddressSaveApi : merchantAddressUpdateApi;
          api(data).then(function () {
            _this2.$message.success(_this2.formData.id === 0 ? '添加成功' : '编辑成功');
            _this2.dialogVisible = false;
            _this2.getList();
          }).catch(function () {
            _this2.btnLoading = false;
          });
        } else {
          return false;
        }
      });
    }),
    /** 列表 */getList: function getList() {
      var _this3 = this;
      this.listLoading = true;
      merchantAddressListApi().then(function (res) {
        _this3.tableData.data = res;
        localStorage.setItem('merchantAddressList', JSON.stringify(res));
        _this3.listLoading = false;
      }).catch(function () {
        _this3.listLoading = false;
      });
    },
    /** 修改状态 */onchangeIsShow: function onchangeIsShow(row) {
      var _this4 = this;
      if (row.isDefault) return;
      merchantAddressUpdateShowApi(row.id).then(function () {
        _this4.$message.success('修改成功');
        _this4.getList();
      }).catch(function () {
        row.status = !row.status;
      });
    },
    /** 设置默认地址 */handleSetIsDefault: function handleSetIsDefault(rowData) {
      var _this5 = this;
      this.$modalSure('设置为默认地址吗?').then(function () {
        merchantAddressSetDefaultApi(rowData.id).then(function () {
          _this5.$message.success('设置成功');
          _this5.getList();
        });
      });
    },
    handleDelAddress: function handleDelAddress(rowData) {
      var _this6 = this;
      this.$modalSure('删除当前数据?').then(function () {
        merchantAddressDeleteApi(rowData.id).then(function () {
          _this6.$message.success('删除成功');
          _this6.getList();
        });
      });
    }
  }
};